import { shallowEqual, useSelector } from 'react-redux';

const selectore = (state) => {
  return state.phrases;
};
export const usePhrases = () => {
  const selectedData = useSelector(selectore, shallowEqual);
  return selectedData;
};
